<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            title="Toutes"
            :pressed="tenFilter === 'all'"
            variant="outline-secondary"
            @click="updateTenFilter('all')"
        >
            Toutes
        </b-button>
        <b-button
            title="Mensuelles"
            :pressed="tenFilter === 'M'"
            variant="outline-primary"
            @click="updateTenFilter('M')"
        >
            M
        </b-button>
        <b-button
            title="Trimestrielles"
            :pressed="tenFilter === 'T'"
            variant="outline-primary"
            @click="updateTenFilter('T')"
        >
            T
        </b-button>
        <b-button
            title="Annuelles"
            :pressed="tenFilter === 'A'"
            variant="outline-primary"
            @click="updateTenFilter('A')"
        >
            A
        </b-button>
        <b-button
            title="Non Imposables"
            :pressed="tenFilter === 'NI'"
            variant="outline-primary"
            @click="updateTenFilter('NI')"
        >
            N/I
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'TenFilter',

    mixins: [DataUpdater],

    methods: {
        updateTenFilter(value) {
            this.$store.commit('browsing/SET_TEN_FILTER', value)
            this.$root.$refs.tenTable.filterItems()
        },
    },

    computed: {
        ...mapState({
            tenFilter: (state) => state.browsing.tenFilter,
        }),
    },
}
</script>

<style scoped></style>
